import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { CurrentUserPermissionsState } from './current-user-permissions-data.service';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([CurrentUserPermissionsState])
  ]
})
export class PermissionsServicesModule { }
